import script from "./NewsPageRubricsSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageRubricsSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageRubricsSwitcher.vue?vue&type=style&index=0&id=80b60926&lang=scss"

const __exports__ = script;

export default __exports__